<template>
  <v-dialog :value="true" persistent max-width="290">
    <v-card>
      <v-card-title class="text-h5">Take resource offline?</v-card-title>
      <v-card-text>{{ warningDialogText }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.native="handleDismiss">Cancel</v-btn>
        <v-btn color="primary" text :loading="loading" @click.native="setUnitStatusToOffline"
          >Take Offline</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    loading: boolean
    unitName?: string
  }>(),
  {
    unitName: 'this resource',
  },
)

const emit = defineEmits(['dismiss', 'update-status'])

const warningDialogText = computed(
  () =>
    `Ensure there are no scheduled/active jobs for this resource. Notify the operator prior to setting ${props.unitName.trim()} offline.`,
)

const handleDismiss = () => {
  emit('dismiss')
}
const setUnitStatusToOffline = () => {
  emit('update-status')
}
</script>
